import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { ApplicantActions } from '../../actions';
import CommentPage from './Comment';
import HistoryPage from './History';
import styles from './Tabs.module.scss';
const Tabs = (props) => {
  const [activeComment, setActiveComment] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    if (props?.selectedId) {
      if (activeComment) {
        dispatch(
          props?.announcementTab
            ? ApplicantActions.announcementCommentGet(props?.selectedId)
            : ApplicantActions.getComment(props?.selectedId)
        );
      } else {
        dispatch(ApplicantActions.getHistory(props?.selectedId));
      }
    }
  }, [props?.selectedId, activeComment]);
  return (
    <div className={styles.historyMain}>
      {props?.announcementTab ?? (
        <div className={styles.tabButtonGroup}>
          <div
            className={`${styles.commentPart} ${
              activeComment ? styles.active : ''
            }`}
            onClick={() => setActiveComment(true)}
          >
            Comments
          </div>
          <div
            className={`${styles.historyPart} ${
              !activeComment ? styles.active : ''
            }`}
            onClick={() => setActiveComment(false)}
          >
            History
          </div>
        </div>
      )}

      {activeComment ? (
        <CommentPage
          selectedId={props?.selectedId}
          announcementTab={props?.announcementTab}
        />
      ) : (
        <HistoryPage selectedId={props?.selectedId} />
      )}
    </div>
  );
};

export default Tabs;
